import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import proxyFormOperations from '../hocs/ProxyFormOperations';
import Types from '../classes/types';
import { lang } from '../services';

import KeyPressInterceptor from './KeyPressInterceptor';
import ButtonWithIcon from './buttons/ButtonWithIcon';
import SvgIcon from './icons/SvgIcon';
import Input from "./form/Input";

const OpenUrlForm = ({
    onChangeTargetURL,
    handleSubmitURL,
    targetURL,
    hasError,
    onClickAgreement = (f) => f,
}) => (
    <div className='OpenUrlForm__wrapper'>
        <div className={classNames('OpenUrlForm', {
            'OpenUrlForm__error': hasError
        })}>
            <div className='OpenUrlForm__row'>
                <Input
                    placeholder={lang.t('Put a URL')}
                    value={targetURL}
                    onChange={onChangeTargetURL}
                />
                <ButtonWithIcon
                    icon={SvgIcon.PROXY}
                    label={lang.t('START')}
                    onClick={handleSubmitURL}
                />
                <KeyPressInterceptor
                    keyCodes={Types.KEY_CODES.ENTER}
                    onKeyPressed={handleSubmitURL}
                />
            </div>
            <div className='OpenUrlForm__row OpenUrlForm__rowAgreement'>
                <div className='OpenUrlForm__agreement'>
                    &rarr;&nbsp;{lang.t('By using the web-proxy you accept the user')}{' '}
                    <span onClick={onClickAgreement} className='OpenUrlForm__agreementLight'>{lang.t('agreement policies')}</span>
                </div>
                {hasError && (
                    <div className='OpenUrlForm__error'>
                        {lang.t('Oh, it seems the link is incorrect. Could you please check the link?')}
                    </div>
                )}
            </div>
        </div>
    </div>
);

OpenUrlForm.propTypes = {
    onChangeTargetURL: PropTypes.func,
    handleSubmitURL: PropTypes.func,
    onClickAgreement: PropTypes.func,
    targetURL: PropTypes.string,
    hasError: PropTypes.bool,
};

export default proxyFormOperations(OpenUrlForm);